import { render } from "./Card.vue?vue&type=template&id=10f79d96"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=10f79d96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__